export default "__VITE_ASSET__b8a52b4c__"